import { FC, RefObject } from 'react';
import { Typography } from '@mui/material';
import { motion, PanInfo } from 'framer-motion';

import './QuickShortcutsSection.scss';
import { ReactComponent as PlusFilledIcon } from '../../../assets/tabs/routine-tab/plus-filled.svg';
import { useTranslation } from 'react-i18next';

interface QuickShortcutsSectionProps {
  shortcuts: string[];
  shortcutListRef: RefObject<HTMLDivElement>;
  onShortcutClick: (shortcut: string) => void;
  onShortcutListPanStart: () => void;
  onShortcutListPan: (event: MouseEvent | TouchEvent | PointerEvent, info: PanInfo) => void;
  onShortcutListPanEnd: () => void;
  titleLeftAdornment?: React.ReactNode;
}

const QuickShortcutsSection: FC<QuickShortcutsSectionProps> = ({
  shortcuts,
  shortcutListRef,
  onShortcutClick,
  onShortcutListPanStart,
  onShortcutListPan,
  onShortcutListPanEnd,
  titleLeftAdornment,
}) => {
  const { t } = useTranslation();

  return (
    <section className="quick-shortcuts-section">
      <div className="quick-shortcuts-section__title-row">
        {titleLeftAdornment}
        <Typography variant="h3" className="quick-shortcuts-section__title">
          {t('routine.quickShortcuts')}
        </Typography>
      </div>
      <motion.div
        ref={shortcutListRef}
        className="quick-shortcuts-section__list"
        onPanStart={onShortcutListPanStart}
        onPan={onShortcutListPan}
        onPanEnd={onShortcutListPanEnd}
        whileTap={{ cursor: 'grabbing' }}
      >
        {shortcuts.map((shortcut) => (
          <button
            key={shortcut}
            type="button"
            className="quick-shortcuts-section__button"
            onClick={() => onShortcutClick(shortcut)}
          >
            <Typography variant="body1" className="quick-shortcuts-section__button__label">
              {shortcut}
            </Typography>
            <PlusFilledIcon className="quick-shortcuts-section__button__icon" />
          </button>
        ))}
      </motion.div>
    </section>
  );
};

export default QuickShortcutsSection;
